/* eslint-disable no-unused-vars */
import Vue from "vue";
import store from "./store";

import App from "./App.vue";

import router from "./router";

import VueMaterial from "vue-material";
import mgr from "./authService.js";
import VueToast from "vue-toast-notification";
import VueHtmlToPaper from "vue-html-to-paper";
// import FullStory from './assets/js/fullstory'

import moment from "moment";

// import { MdButton, MdContent, MdTabs } from 'vue-material/dist/components'
// import 'bootstrap'
import "../src/assets/css/bundle.min.css";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.prototype.moment = moment;

Vue.use(VueToast);
Vue.use(VueMaterial);
Vue.use(VueHtmlToPaper);
Vue.config.productionTip = false;

const globalData = {
  isAuthenticated: false,
  user: "",
  mgr: mgr,
};
const globalMethods = {
  async authenticate(returnPath) {
    const user = await this.$root.getUser(); //see if the user details are in local storage
    if (!!user) {
      this.isAuthenticated = true;
      this.user = user;
    } else {
      await this.$root.signIn(returnPath);
    }
  },
  async getUser() {
    try {
      let user = await this.mgr.getUser();
      return user;
    } catch (err) {
      console.log(err);
    }
  },
  signIn(returnPath) {
    returnPath
      ? this.mgr.signinRedirect({ state: returnPath })
      : this.mgr.signinRedirect();
  },
};

new Vue({
  router,
  data: globalData,
  methods: globalMethods,
  mixins: globalMethods,
  render: (h) => h(App),
  store,
}).$mount("#app");
